import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "../src/assets/main.css";
import Routing from "./Routing";
import config from "react-global-configuration";
import { Provider } from "react-redux";

import store from "./store";
config.set({
  apiUrl: process.env.REACT_APP_apiUrl,
  enc_key: process.env.REACT_APP_enc_key,
  enc_iv: process.env.REACT_APP_enc_iv,
  project_title: process.env.REACT_APP_project_title,
  web_cookie_url: process.env.REACT_APP_web_cookie_url,
  support_app_token: process.env.REACT_APP_support_app_token,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Routing />
  </Provider>
);
